import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "./constants";

export class StreamingError extends Error {
  constructor(message: string, public code?: string) {
    super(message);
    this.name = "StreamingError";
  }
}

export const handleError = (error: string | Error, showToast = true) => {
  const message = error instanceof Error ? error.message : error;
  console.error("[LiveStreaming Error]:", message);

  if (showToast) {
    toast.warning(message);
  }

  return message;
};

export const handleSuccess = (message: string, showToast = true) => {
  console.log("[LiveStreaming Success]:", message);

  if (showToast) {
    toast.success(message);
  }

  return message;
};

export const validateGiftSending = (
  streamStatus: any,
  userTokens: number,
  giftPrice: number,
  allOrNothing: boolean,
  receiverId?: string | null
) => {
  if (!streamStatus) {
    throw new StreamingError(ERROR_MESSAGES.STREAM_STATUS_LOADING);
  }

  const organiserStreamCompleted = streamStatus?.organiser === "completed";
  const challengerStreamCompleted = streamStatus?.challenger === "completed";

  if (organiserStreamCompleted && challengerStreamCompleted) {
    throw new StreamingError(ERROR_MESSAGES.EVENT_ENDED);
  }

  if (userTokens < giftPrice) {
    throw new StreamingError(ERROR_MESSAGES.INSUFFICIENT_TOKENS);
  }

  // Only check if receiver is provided when not in allOrNothing mode
  if (!allOrNothing && !receiverId) {
    throw new StreamingError(ERROR_MESSAGES.SELECT_PLAYER);
  }

  return true;
};

export const formatDisplayMessage = (
  eventTitle: string,
  eventStatus: string,
  isWithinValidTime: boolean,
  organiserStreamCompleted: boolean,
  resultSubmitted: boolean,
  dispute: boolean,
  winner: string | null
) => {
  if (eventStatus === "upcoming" || !isWithinValidTime) {
    return `${eventTitle} Event is About to Begin`;
  }

  if (organiserStreamCompleted) {
    if (!resultSubmitted) {
      return `${eventTitle} has come to an end and we are waiting for the results.`;
    }
    if (resultSubmitted && dispute) {
      return `${eventTitle} has come to an end and a dispute has been raised.`;
    }
    if (resultSubmitted && !dispute) {
      return `${eventTitle} has come to an end and the winner is ${winner}.`;
    }
  }

  return `${eventTitle} is live.`;
};

export const getShareUrl = (baseUrl: string, eventId: string): string => {
  return `${baseUrl}/LiveStreaming?eventId=${eventId}`;
};

export const createShareUrls = (url: string) => {
  const encodedUrl = encodeURIComponent(url);

  return {
    whatsapp: `https://wa.me/?text=${encodedUrl}`,
    instagram: `instagram://sharesheet?text=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
    facebook: `https://www.messenger.com/t/?message=${encodeURIComponent(
      `Check out this link: ${url}`
    )}`,
  };
};

export const getPlayerLabel = (
  participantDetails: any[],
  organiserId: string
): {
  organizer: any;
  challenger: any;
  organizerName: string;
  challengerName: string;
} => {
  const organizer =
    participantDetails?.find(
      (participant) => participant.userID === organiserId
    ) || {};

  const challenger =
    participantDetails?.find(
      (participant) => participant.userID !== organiserId
    ) || {};

  return {
    organizer,
    challenger,
    organizerName: organizer?.userID || "Player 1",
    challengerName: challenger?.userID || "Player 2",
  };
};
